import * as React from 'react';
import { Popover, PopoverInteractionKind } from '@blueprintjs/core';

export interface IPortalPopoverProps {
    target: string | JSX.Element;
    content: string | JSX.Element;
    portalContainer: HTMLElement;
    isOpen: boolean;
    portalClassName: string;
    popoverClassName: string;
    onClose?: (e) => void;
}

const PortalPopover: React.FunctionComponent<IPortalPopoverProps> = (props) => {
    return (
        <Popover
            enforceFocus={true}
            interactionKind={PopoverInteractionKind.CLICK}
            position={'bottom-left'}
            usePortal={true}
            minimal={true}
            autoFocus={true}
            rootBoundary={'viewport'}
            modifiers={{
                offset: {
                    data: [0, 0],
                },
                flip: {
                    enabled: false,
                },
            }}
            portalClassName={props.portalClassName}
            popoverClassName={props.popoverClassName}
            portalContainer={props.portalContainer}
            // isOpen={props.isOpen}
            onClose={props.onClose}
            content={props.content}
            transitionDuration={0}
            hoverOpenDelay={0}
            hoverCloseDelay={100}
        >
            {props.target}
        </Popover>
    );
};

PortalPopover.displayName = 'PortalPopover';

export default PortalPopover;
